import { IAutoMapper } from "../interfaces";

export const mapJobQueueUnRead = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "JobQueueUnRead")
    .forMember("unReadCount", o => o.unReadCount)
    .forMember("newCount", o => o.newCount);
};
